import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { InnerForm } from '../../routes/Login/Login';
import { withFormik } from 'formik';
import { signInAction } from '../../actions/UserActions';
import * as Yup from 'yup';

import { 
  ModalLoginWrapper,
  ModalLoginH2,
  ModalLoginContent
} from '../HelperComponents/StyledComponents';

import {
  closeModal
} from '../../actions/ModalLoginActions';

class ModalLoginComponent extends Component {
  state = {
    isOpen: false
  }

  handleLogin = (values, { _props, setSubmitting, _setErrors}) => {
    this.props.dispatch(signInAction({ username: values.username, password: values.password }, this.props.history));

    setSubmitting(false);
  }

  render() {
    // Wrap our form with the using withFormik HoC
    const MyForm = withFormik({
      validationSchema: Yup.object({
        username: Yup.string().required('Username or Email Address is required'),
        password: Yup.string().required('Password is required'),
      }),
      // Transform outer props into form values
      mapPropsToValues: _props => ({ username: '', password: '' }),
      // Submission handler
      handleSubmit: this.handleLogin,
    })(InnerForm);

    return (
      <div className={`modal ${this.props.modalLogin.isOpen && !this.props.user.authenticated ? 'is-active' : ''}`}>
        <div className="modal-background">
        </div>
        <div className="modal-content is-clipped">
          <section className="columns is-centered">
            <section className="column is-6">
              <ModalLoginWrapper className="card">
                <header className="card-header">
                  <ModalLoginH2 className="card-header-title has-text-white">Log In</ModalLoginH2>
                </header>
                <div className="card-content">
                  <div className="content has-text-white">
                    <ModalLoginContent>Please log in to download tracks! <br /> Don’t have an account? <Link to="/sign-up" className="has-text-white"><b>Sign Up</b></Link> </ModalLoginContent>
                    <MyForm />
                  </div>
                </div>
              </ModalLoginWrapper>
            </section>
          </section>
        </div>
        <button className="modal-close is-large" aria-label="close" onClick={() => this.props.dispatch(closeModal())}></button>
      </div>
    );
  }
}

function mapStateToProps({ user, modalLogin }) {
  return {
    modalLogin,
    user
  };
}

export const ModalLogin = withRouter(connect(mapStateToProps)(ModalLoginComponent));



// WEBPACK FOOTER //
// ./src/components/ModalLogin/ModalLogin.js